import { useState } from "react";
import "./LoginModal.css";

const LoginModal = ({ onClose, onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    setError("");

    if (!email || !password) {
      setError("Compila tutti i campi");
      return;
    }

    if (!email.includes("@")) {
      setError("Inserisci un'email valida");
      return;
    }

    const userData = {
      id: Math.random().toString(36).substr(2, 9),
      email: email,
      name: email.split("@")[0],
      loginTime: new Date().toLocaleString("it-IT"),
    };

    onLogin(userData);
    onClose();
  };

  const handleDemoLogin = () => {
    const demoUser = {
      id: "demo123",
      email: "utente@example.com",
      name: "Utente Demo",
      loginTime: new Date().toLocaleString("it-IT"),
    };
    onLogin(demoUser);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          ✕
        </button>

        <h2>Accedi al tuo account</h2>

        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tue.mail@example.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Inserisci la password"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="login-submit-btn">
            Accedi
          </button>
        </form>

        <div className="demo-login">
          <p>Vuoi provare prima?</p>
          <button onClick={handleDemoLogin} className="demo-btn">
            Accedi come Ospite Demo
          </button>
        </div>

        <p className="login-note">
          Nota: Questo è un sito demo. Puoi usare qualsiasi email e password.
        </p>
      </div>
    </div>
  );
};

export default LoginModal;
